/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Invitation_PendingInputs */

const fr_account_audit_invitation_pending = /** @type {(inputs: Account_Audit_Invitation_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation en attente`)
};

/**

* @param {Account_Audit_Invitation_PendingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_invitation_pending = /** @type {((inputs?: Account_Audit_Invitation_PendingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Invitation_PendingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_invitation_pending(inputs)
});